<div class="main-content">
    <div class="container-fluid">
        <div class="card sq-card">
            <div class="card-header card-header-squirrel">
                <h4>{{userDto.userName}} ({{userDto.email}})</h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <mat-tab-group dynamicHeight preserveContent animationDuration="0">
                            <!-- <mat-tab label="{{this.translate.data['USERINFO'] | translate}}">
                                <ng-template matTabContent>
                                    <edit-user-profile-info [user]="userDto"></edit-user-profile-info>
                                </ng-template>                                
                            </mat-tab> -->
                            <mat-tab label="{{this.translate.data['GRPROLESPERMISSION'] | translate}}" *ngIf="showTenantGrpRoles">
                                <ng-template matTabContent>
                                    <!-- <platform-group-roles-permissions [user]="userDto"></platform-group-roles-permissions> -->
                                    <tenant-grouproles [user]="userDto"></tenant-grouproles>
                                </ng-template>                                
                            </mat-tab>
                            <mat-tab label="{{this.translate.data['TENANTINFO'] | translate}}" *ngIf="admin">
                                <ng-template matTabContent>
                                    <tenant-info [user]="userDto"></tenant-info>
                                </ng-template>                                
                            </mat-tab>
                            <!-- <mat-tab label="{{this.translate.data['CHANGEPASSWORD'] | translate}}">
                                <ng-template matTabContent>
                                    <change-password [user]="userDto"></change-password>
                                </ng-template>                                
                            </mat-tab> -->
                          </mat-tab-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>